import { render, staticRenderFns } from "./emailTemplateItem.vue?vue&type=template&id=602dc7f6&scoped=true"
import script from "./emailTemplateItem.vue?vue&type=script&lang=js"
export * from "./emailTemplateItem.vue?vue&type=script&lang=js"
import style0 from "./emailTemplateItem.vue?vue&type=style&index=0&id=602dc7f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602dc7f6",
  null
  
)

export default component.exports